// eslint-disable-next-line jira/filename-case
import React from 'react';
import { AsImg } from './AsImg.tsx';
import type {
	IllustrationProps,
	IllustrationCoreProps,
	IllustrationFn,
	AsImgProps,
} from './IllustrationFn.types.tsx';

// this level of indirection is a provision to future-proof this component
// we may want to add extra "render as" in the future
// (note: as of 2023/11 unsure of the exact API, the ENGHEALTH campaign will help clarify the needs, tracked in ERAI-1592)
export function Illustration<Props extends IllustrationProps = AsImgProps>({
	embedAs,
	...props
}: Props): React.JSX.Element {
	return <AsImg {...props} />;
}

/**
 * Illustration factory.
 * @agent-skills: static-assets
 */
export function createIllustration<Props extends IllustrationProps = AsImgProps>({
	srcLight,
	srcDark,
	autoDark,
}: IllustrationCoreProps & Pick<IllustrationProps, 'autoDark'>): IllustrationFn<Props> {
	return (props) => (
		<Illustration srcLight={srcLight} srcDark={srcDark} autoDark={autoDark} {...props} />
	);
}
